import moment from 'moment';
import getAlerts from "./get-alerts";

const downloadNotifications = ({ onProgress } = {}) => {
  return new Promise(async (resolve, reject) => {

    const alerts = await getAlerts(false);

    try {
      let page = 0;
      const perPage = 100;
      let allItems = [];
      let totalCount = null;

      // 1) Pull pages until we've got them all
      while (true) {
        const response = await window.apiRequest(
          'get',
          `/user/notifications?page=${page}&items_per_page=${perPage}`,
        );

        if (response.type !== 'success') {
          throw new Error('Failed to fetch notifications');
        }

        const { items, count } = response.data;
        if (totalCount === null) {
          totalCount = Number(count);
        }

        // if the API ever returns zero items, stop paginating
        if (!items.length) {
          break;
        }

        allItems = allItems.concat(items);

        // report progress
        const fetched = allItems.length;
        if (typeof onProgress === 'function') {
          onProgress({ fetched, total: totalCount, page });
        }
        window.dispatchEvent(new CustomEvent('downloadNotificationsStatus', {
          detail: { fetched, total: totalCount, page }
        }));

        // if we’ve already pulled as many as the API told us exist, stop
        if (allItems.length >= totalCount) {
          break;
        }

        // if fewer than a full page came back, we’re on the last page
        if (items.length < perPage) {
          break;
        }

        page += 1;
      }

      // 3) Generate CSV
      let csv = 'Timestamp,Alert,Sensor,Event\n';
      allItems.forEach(item => {
        let event = `${item.event_type} ${item.event_message}`
          .replace(/\sF/g, '°F')
          .replace(/\sC/g, '°C');
        const created = window.getUserTimezoneDate(item.created);

        let alertName = `Deleted alert ${item.alert_id}`;

        if(item.alert_id && alerts[item.alert_id]) {
          alertName = alerts[item.alert_id].alert_name;
        }

        let sensorName = item.sensor
          ? item.sensor.sensor_name
          : `Deleted sensor ${item.sensor_id}`;

        // escape quotes
        alertName = alertName.replace(/"/g, '""');
        sensorName = sensorName.replace(/"/g, '""');

        csv += `"${created.format('MMM D, h:mm a')}","${alertName}","${sensorName}","${event}"\n`;
      });

      // 4) Trigger download
      const blob = new Blob([ '\ufeff', csv ], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `temp-stick-notifications--${moment().format('YYYY-MM-DD')}.csv`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      resolve();
    } catch (err) {
      reject(err);
    }
  });
};

export default downloadNotifications;
